import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const sectors = [];
export default function SectorExpertise() {
  return <section data-section-id="222535" id="կիրառման-ոլորտները" className="bg-background text-foreground w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
        {sectors.map((sector, i) => <div key={i} data-index={i} className="relative aspect-square md:aspect-video group overflow-hidden">
            {}
            <div className={`absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110 ${sector.bgClass}`} />
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/40 to-transparent transition-colors duration-500 group-hover:from-background/95" />

            {}
            <div className={`${sector.subtitleClassName || ""} absolute inset-0 p-8 md:p-12 flex flex-col justify-between`}>
              <div className="flex-1">
                <p className="font-default text-[14px] font-normal uppercase tracking-widest text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-500 max-w-[90%] md:max-w-[80%]">
                  {sector.subtitle}
                </p>
              </div>

              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-6 sm:gap-4">
                <h3 className="font-default text-2xl md:text-[32px] font-bold text-foreground leading-tight max-w-[80%] uppercase tracking-tighter">
                  {sector.title}
                </h3>
                <Button asChild variant="outline" className="rounded-md border-primary text-primary bg-transparent hover:bg-primary hover:text-primary-foreground text-[12px] h-auto py-2.5 px-5 uppercase tracking-wider shrink-0 transition-all duration-300 shadow-md">
                  <Link to={sector.link}>{sector.Text}</Link>
                </Button>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}